import script from "./EmbraceYourMagicMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbraceYourMagicMobile.vue?vue&type=script&setup=true&lang=js"

import "./EmbraceYourMagicMobile.vue?vue&type=style&index=0&id=efd080b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd080b8"]])

export default __exports__